<template>
  <div class="my-3">
    <div v-if="getProgramById.active === 1">
      <label>Edit {{ Name }}</label>
      <div class="row p-3">
        <div class="col-sm-12 col-md-12 col-lg-12 border p-3">
          <form v-on:submit.prevent="updateProgramOrContest()">
            <div class="row my-3">
              <div class="col-sm-12 col-lg-6 col-md-6">
                <label>Name</label>
              </div>
              <div class="col-sm-12 col-lg-6 col-md-6">
                <form v-on:submit.prevent="updateProgramOrContestName()">
                  <b-form-input type="text" v-model="NewName"></b-form-input>
                  <input class="btn btn-primary btn-lg btn-sm-block mr-2 my-2" type="submit" name="add" value="Update Name" />
                </form>
                <br />
                <small
                  >* Use caution when changing the program or contest name. If there are already records recorded for this program they will show up
                  under the new name. This can be confusing. Consider creating a new program or contest instead.</small
                >
              </div>
            </div>
            <div class="row my-3">
              <div class="col-sm-12 col-lg-6 col-md-6">
                <label>Default points</label>
              </div>
              <div class="col-sm-12 col-lg-6 col-md-6">
                <b-form-input type="text" v-model="DefaultPoints"></b-form-input>
              </div>
            </div>
            <div class="row my-3">
              <div class="col-sm-12 col-lg-6 col-md-6">
                <label>Select Location or companies for this program/contest</label>
                <p>Hold down the control key to select multiple locations.</p>
              </div>
              <div class="col-sm-12 col-lg-6 col-md-6">
                <b-form-select v-model="Companies" :options="CompaniesOption" :select-size="4" multiple></b-form-select>
              </div>
            </div>
            <div class="row my-3">
              <div class="col-sm-12 col-lg-6 col-md-6">
                <label>Add Points: Default Congratulatory Note</label>
                <p>
                  This note appears in the customers account history next to the added points.
                </p>
              </div>
              <div class="col-sm-12 col-lg-6 col-md-6">
                <b-form-textarea
                  v-model="CongratulatoryNote"
                  type="text"
                  id="textarea"
                  placeholder="Enter Your Message Here..."
                  rows="3"
                  max-rows="6"
                ></b-form-textarea>
              </div>
            </div>
            <!-- <div class="row my-3">
              <div class="col-sm-12 col-lg-6 col-md-6" style="display: flex">
                <b-form-checkbox id="checkbox-1" v-model="PostCongratulatoryNote" name="checkbox-1" :value="true"> </b-form-checkbox>
                <p>
                  Also post Default Congratulatory Note on the Customer's Notifications section of the Social Recognition Wall
                </p>
              </div>
              <div class="col-sm-12 col-lg-6 col-md-6" style="display: flex">
                <b-form-checkbox id="checkbox-2" v-model="PostSummaryNotification" name="checkbox-2" :value="true"> </b-form-checkbox>
                <p>
                  Post summary notification on General News Feed section of the Social Recognition Wall
                </p>
              </div>
            </div> -->
            <div class="row my-3">
              <div class="col-sm-12 col-lg-6 col-md-6">
                <label>Add Points: Default Email Subject</label>
              </div>
              <div class="col-sm-12 col-lg-6 col-md-6">
                <b-form-input id="emailSubject" type="text" v-model="EmailSubject"></b-form-input>
              </div>
            </div>
            <div class="row my-3">
              <div class="col-sm-12 col-lg-6 col-md-6">
                <label>Add Points: Default Email Message</label>
                <p>
                  This note is emailed to the recipients when you add points using this program/contest.
                </p>
              </div>
              <div class="col-sm-12 col-lg-6 col-md-6">
                <b-form-textarea
                  id="emailMessage"
                  v-model="EmailMessage"
                  placeholder="Enter Your Message Here..."
                  rows="3"
                  max-rows="6"
                  type="text"
                ></b-form-textarea>
              </div>
            </div>
            <div class="row m-2">
              <div class="col-sm-12 col-lg-6 col-mg-6">
                <input class="btn btn-primary btn-lg btn-sm-block m-2" type="submit" name="edit" value="Update This Program/Contest" />
              </div>
              <div class="col-sm-12 col-lg-6 col-mg-6">
                <appActivateDeactivateProgram
                  v-bind:params="{
                    programId: getProgramById.program_id,
                    isActive: getProgramById.active,
                  }"
                ></appActivateDeactivateProgram>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
    <div v-else-if="getProgramById.active === 0">
      <label>Edit {{ Name }}</label>
      <div class="row p-3">
        <div class="col-sm-12 col-md-12 col-lg-12 border p-3">
          <appActivateDeactivateProgram
            v-bind:params="{
              programId: getProgramById.program_id,
              isActive: getProgramById.active,
            }"
          ></appActivateDeactivateProgram>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PointProgramsActivateDeactivateProgramsContest from '@/views/admin/users/pointPrograms/PointProgramsActivateDeactivateProgramsContest.vue';

export default {
  name: 'PointProgramsEditProgramContest',

  components: {
    appActivateDeactivateProgram: PointProgramsActivateDeactivateProgramsContest,
  },

  data() {
    return {
      ProgramId: this.$route.params.programId,
      Name: '',
      NewName: '',
      DefaultPoints: 0,
      Companies: [],
      CompaniesOption: [],
      CongratulatoryNote: '',
      PostCongratulatoryNote: false,
      PostSummaryNotification: false,
      EmailSubject: '',
      EmailMessage: '',
    };
  },

  methods: {
    updateProgramOrContestName: function() {
      console.log('hello from update name');
      const params = {
        programId: +this.ProgramId,
        name: this.NewName,
      };

      if (params.name) {
        this.$store.dispatch('systemMessage/setMessage', {
          message: '',
        });

        this.$store
          .dispatch('adminPointPrograms/updateProgramName', params)
          .then((resp) => {
            if (resp) {
              this.$store.dispatch('systemMessage/setMessage', {
                message: 'Your program NAME has been changed',
              });

              // updating latest program in store
              this.$store.dispatch('adminPointPrograms/fetchProgramDetailsById', {
                programId: +this.ProgramId,
              });

              // updating latest program list in store
              this.$store.dispatch('adminPointPrograms/fetchProgrammes', {
                allClientSelect: false,
                userType: this.getUserClients.userType ? this.getUserClients.userType : 0,
                clientIds: this.getUserClients.clients.lenth > 0 ? this.getUserClients.clients : [+this.getUserClients.client],
              });

              this.scrollToTop();
            }
          })
          .catch(() => {
            console.log('some error from edit program name');
          });
      } else {
        this.$store.dispatch('systemMessage/setMessage', {
          message: 'Your program must at least have a name.',
        });
      }
    },
    updateProgramOrContest: function() {
      console.log('hello from all');
      let params = {
        program_id: +this.ProgramId,
        name: this.NewName,
        userClientId: +this.getUserClients.client,
        client_ids: this.Companies,
        presetPoints: +this.DefaultPoints,
        presetCongratulatoryNote: this.CongratulatoryNote,
        presetEmailMessage: this.EmailMessage,
        presetEmailSubject: this.EmailSubject,
        postContratulatoryNote: this.PostCongratulatoryNote,
        postSummaryNotification: this.PostSummaryNotification,
      };

      console.log(params);

      if (params.client_ids.some((val) => val === null)) {
        params.client_ids = [];
        this.CompaniesOption.map((company) => {
          if (company.value !== null) {
            params.client_ids.push(company.value);
          }
        });
      }

      if (params.name) {
        this.$store
          .dispatch('adminPointPrograms/updateProgram', params)
          .then((programId) => {
            this.scrollToTop();
            console.log(programId, 'updated program');
            if (programId) {
              this.$store.dispatch('systemMessage/setMessage', {
                message: 'Your program has been updated.',
              });

              // updating latest program in store
              this.$store.dispatch('adminPointPrograms/fetchProgramDetailsById', {
                programId: +this.ProgramId,
              });

              // updating latest program list in store
              this.$store.dispatch('adminPointPrograms/fetchProgrammes', {
                allClientSelect: false,
                userType: this.getUserClients.userType ? this.getUserClients.userType : 0,
                clientIds: this.getUserClients.clients.lenth > 0 ? this.getUserClients.clients : [+this.getUserClients.client],
              });
            }
          })
          .catch(() => {
            console.log('error from update program store.');
          });
      } else {
        this.$store.dispatch('systemMessage/setMessage', {
          message: 'Your program must at least have a name.',
        });
      }
    },
    setMessage: function() {
      this.$store.dispatch('systemMessage/setMessage', {
        message: '',
      });
    },
    scrollToTop() {
      window.scrollTo(0, 0);
    },
  },

  computed: {
    getProgramById() {
      return this.$store.getters['adminPointPrograms/getProgramById'];
    },
    authorizedClients() {
      return this.$store.getters['adminPointPrograms/getAuthorizedClients'];
    },
    getUserClients() {
      return this.$store.getters['user/getUserClients'];
    },
  },

  watch: {
    getProgramById(getProgramById) {
      (this.Name = getProgramById.name),
        (this.NewName = getProgramById.name),
        (this.DefaultPoints = getProgramById.presetPoints),
        // (this.Companies = Array.isArray(getProgramById.clientIds)
        //   ? getProgramById.clientIds
        //   : [getProgramById.userClientId]),
        (this.CongratulatoryNote = getProgramById.presetCongratulatoryNote),
        (this.PostCongratulatoryNote = getProgramById.postContratulatoryNote),
        (this.PostSummaryNotification = getProgramById.postSummaryNotification),
        (this.EmailSubject = getProgramById.presetEmailSubject),
        (this.EmailMessage = getProgramById.presetEmailMessage);
    },
    authorizedClients(authorizedClients) {
      var datas = [{ value: null, text: 'Apply to all locations' }];
      authorizedClients.map(function(data) {
        datas.push({
          value: data.clientId,
          text: data.clientName,
        });
      });

      this.CompaniesOption = datas;
    },
  },

  created() {
    this.setMessage();
    this.$store.dispatch('adminPointPrograms/fetchProgramDetailsById', {
      programId: +this.ProgramId,
    });
    this.$store.dispatch('adminPointPrograms/fetchAuthorizedClients');
    this.$store
      .dispatch('adminAddPoint/fetchClientsByProgrammeId', {
        programId: +this.ProgramId,
      })
      .then((data) => {
        this.Companies = data.map((client) => client.clientId);
      });
  },
};
</script>

<style lang="scss" scoped></style>
